import { useParams } from 'react-router-dom';
import { PageHeading } from '@bcecloud/portal-ui';
import { formatEventDay } from '@/lib/program-profitability';
import { useEventPnl } from '@/lib/event-pnl';
import { EventPnlReport, EventPnlSalesforceButtons, EventPnlStates } from '@/components/event-pnl';

/**
 * Analytics → Accounting → Event P&L: one event's Income & Expense Statement
 * and every expense line, with buttons to the Salesforce records. Not in the
 * nav; the Programs, Facilitators and event pages link here. Behind
 * view_accounting (the route guard and the API both check it).
 */
export function EventPnlPage(): React.ReactElement {
  const { opportunityId = '' } = useParams();
  const query = useEventPnl(opportunityId);
  const header = query.data?.header;
  const subtitle = header
    ? [header.accountName, header.eventDate ? formatEventDay(header.eventDate) : ''].filter(Boolean).join(' · ')
    : '';

  return (
    <section className="animate-portal-rise">
      <PageHeading
        breadcrumbs={[{ label: 'Accounting' }, { label: 'Event P&L' }]}
        title={header?.opportunityName || 'Event P&L'}
        {...(subtitle ? { subtitle } : {})}
        size="compact"
        {...(query.data ? { action: <EventPnlSalesforceButtons data={query.data} /> } : {})}
      />
      <EventPnlStates query={query}>{(data) => <EventPnlReport data={data} />}</EventPnlStates>
    </section>
  );
}
